module.exports = __webpack_public_path__ + "static/img/214.65c5b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/214.png
// module id = RL8l
// module chunks = 1